import Login from '../views/Login.vue';
// import Index from '../views/Index.vue';
import Template from '@/layouts/Template.vue';
import NewsDetails from '../views/industryNews/newsDetails.vue';
export default [
    {
        path: '/',
        name: 'login',
        component: Login,
        hidden: true
    },
    {
        path: '/',
        name: '首页',
        component: Template,
        hidden: true,
        children: [
            {
                path: '/newsDetails',
                name: '动态详情',
                component: NewsDetails,
                hidden: true
            }
        ]
    },
    {
        path: '/index',
        name: '首页',
        component: Template
    }
    // {
    //     id: '1',
    //     path: '/',
    //     component: Home,
    //     name: '管理中心',
    //     iconCls: 'md-settings', // 图标样式class
    //     children: [
    //         { id: '1-1', path: '/list', component: User, name: '新闻管理' },
    //         {
    //             id: '1-2',
    //             path: '/listDetail',
    //             component: User,
    //             name: 'listDetail',
    //             parentPath: '/list',
    //             hidden: true
    //         },
    //         { id: '1-3', path: '/Nav1', component: User, name: 'Nav1' }
    //     ]
    // },
    // {
    //     id: '2',
    //     path: '/',
    //     component: Home,
    //     name: '系统管理',
    //     iconCls: 'ios-paper', // 图标样式class
    //     children: [
    //         { id: '2-1', path: '/index', component: User, name: '主页', hidden: true },
    //         { id: '2-2', path: '/userCenter', component: User, name: '用户管理' },
    //         { id: '2-3', path: '/nav1', component: User, name: 'Nav11' }
    //     ]
    // }
];
